import React, { Component } from 'react';

import { COLORS } from '../../assets/js/constants';
import { btnTypes } from '../../components/buttons/baseButton';
import * as ST from './styled';

const headerTheme = {
    white: {
        fill: COLORS.white,
        fontColor: COLORS.black,
        activeItem: COLORS.blue,
    },
    whiteTransparent: {
        fill: 'rgba(255, 255, 255, 0.9)',
        fontColor: COLORS.black,
        activeItem: COLORS.blue,
    },
    black: {
        fill: 'rgba(0, 0, 0, 0.9)',
        fontColor: COLORS.white,
        activeItem: '#56ccf2',
    },
};

class Header extends Component {
    static defaultProps = {
        theme: 'white',
        activeSelector: 'link',
    }

    render() {
        const { transitionDelay, title, menuList, actionTitle, actionCallback, active, children, theme, activateMenu, activeSelector, ...props } = this.props;

        const styles = headerTheme[theme];

        let menu;
        if (menuList) {
            menu = menuList.map((item, index) => <ST.MenuItem key={ index }
                transitionDelay={transitionDelay}
                activeElem={ active && item[activeSelector] === active[activeSelector] }
                onClick={ () => activateMenu(item) }
                styles={ styles }
            >{ item.title }</ST.MenuItem>);
        }

        return (
            <ST.Container transitionDelay={transitionDelay} fill={ styles.fill } { ...props }>
                <ST.Title transitionDelay={transitionDelay} styles={ styles }>{ title }</ST.Title>
                <ST.MenuContainer>
                    { children }
                    { menuList ? <ST.MenuList>{ menu }</ST.MenuList> : null }
                    { actionTitle
                        ? <ST.ActionButton type={ btnTypes.ACCENT } text={ actionTitle } onClick={ actionCallback }/>
                        : null }
                </ST.MenuContainer>
            </ST.Container>
        );
    }
}

export default Header;
